import { Api } from "./keymanageRpcApi";

export let rootKmsRpcApi = new Api();
